<div class="bubble"
     [class]="['bubble--'+position(), 'bubble--'+theme()]"
     [class.bubble--visible]="visible()"
     [style.width]="width()"
     [style.height]="height()"
     [style.font-size]="fontSize()"
     [style.left]="left() + 'px'"
     [style.top]="top() + 'px'">
  <span class="bubble-close" (click)="close()">&#x2715;</span>
  {{tip()}}
</div>
